import React from 'react';
import { Box } from '@mui/material';

export function Page({ children, ...props }) {
  return <Box sx={{ minHeight: '60vh', ...props?.sx }} {...props}>{children}</Box>;
}
